import Splide from '@splidejs/splide';

const initClientsSlider = (slider) => {
  const columnsCount = slider.querySelectorAll('.splide__slide').length;

  if (!columnsCount) {
    return;
  }

  const splide = new Splide(slider, {
    type: columnsCount > 1 ? 'loop' : 'slide',
    perPage: 6,
    perMove: 1,
    focus: 0,
    gap: '1.25rem',
    omitEnd: false,
    arrows: columnsCount > 1,
    pagination: columnsCount > 1,
    speed: 650,
    drag: columnsCount > 1,
    keyboard: 'focused',
    breakpoints: {
      1024: {
        perPage: 3,
      },
      640: {
        perPage: 2,
        gap: '0.75rem',
      },
    },
    reducedMotion: {
      speed: 0,
      rewindSpeed: 0,
    },
  });

  splide.on('overflow', (isOverflow) => {
    slider.classList.toggle('clients-slider__slider--static', !isOverflow);
  });

  splide.mount();
};

const initClientsSliders = () => {
  document.querySelectorAll('.clients-slider__slider').forEach((slider) => {
    if (slider.classList.contains('is-initialized')) {
      return;
    }

    initClientsSlider(slider);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initClientsSliders);
} else {
  initClientsSliders();
}
